// extracted by mini-css-extract-plugin
export default {"main":"Info_main__+JfuC","imgCont":"Info_imgCont__Ckb6K","list":"Info_list__6PNMJ","listItem":"Info_listItem__FgN+4","head":"Info_head__ouYzU"};